import {BaseService} from "@/core/services/BaseService";

class ActionViewService extends BaseService<any> {
  endpoint = "/action-view";
}

export default new ActionViewService();